import React, { useState, useEffect, useRef } from "react";

import { IonIcon } from "@ionic/react";
import { closeCircle } from "ionicons/icons";
import FilterSvg from "../../../theme/images/filter.svg";
import styles from "./filters.module.css";
interface State {
  dropdownStatus: boolean;
}

interface Option {
  id: string;
}

const DropdownCheckbox: React.FC<{
  options: Option[];
  onFilterChange: Function;
  onRemoveAll: Function;
  selected: string[];
  name: string;
}> = (props) => {
  const [state, setState] = useState<State>({
    dropdownStatus: false,
  });
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setState((prevState) => ({ ...prevState, dropdownStatus: false }));
    }
  };

  const onToggle = () => {
    setState({ ...state, dropdownStatus: !state.dropdownStatus });
  };

  return (
    <>
      <div ref={dropdownRef}>
        <div className={styles.btnNavigation}>
          <button
            className={`btn btn-xs btn-ionic-light btn-flex ${styles.btnHeader}`}
            onClick={() => onToggle()}
          >
            <div className={styles.btnImageFilter}>
              <img src={FilterSvg} />
            </div>
            <div>
              <div className="d-flex">
                {props.name}
                {props.selected.length ? (
                  <div style={{ marginLeft: "3px" }}>
                    <div className="badge color-visito-1-bg">
                      {props.selected.length}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </button>
        </div>

        <div
          className={styles.dropdownContainer}
          style={{ display: state.dropdownStatus ? "inherit" : "none" }}
        >
          <div className={styles.dropdownBody}>
            {props.options.map((o: { id: string; name?: string }) => (
              <div className="form-check" key={o.id}>
                <input
                  className="form-check-input primary"
                  type="checkbox"
                  onChange={(e) =>
                    props.onFilterChange({
                      field: e.target.id,
                      checked: e.target.checked,
                    })
                  }
                  id={o.id}
                  checked={props.selected.includes(o.id)}
                />
                <label
                  className="form-check-label fs-2 fw-semibold-1 pointer"
                  htmlFor={o.id}
                >
                  {o.name}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
      {props.selected.length && props.onRemoveAll ? (
        <IonIcon
          style={{ opacity: "50%", marginLeft: "3px" }}
          icon={closeCircle}
          className="pointer"
          size="small"
          onClick={() => props.onRemoveAll([])}
        ></IonIcon>
      ) : null}
    </>
  );
};
export default DropdownCheckbox;

export const Filter: React.FC<{
  options: { id: string; name?: string }[];
  onFilterChange: (filter: string[]) => void;
  name: string;
  currentFilters: string[];
}> = (props) => {
  const { options, name } = props;
  const [filters, setFilters] = useState<string[]>([]);

  const onNewValues = (filter: string[]) => {
    setFilters(filter);
    props.onFilterChange(filter);
  };
  return (
    <>
      <DropdownCheckbox
        options={options}
        name={name}
        onFilterChange={(change: any) => {
          const { field, checked } = change;
          const value = field.toString();
          const updatedValues = checked
            ? Array.from(new Set([...filters, value])) // añade sin duplicados
            : filters.filter((item) => item !== value); // elimina
          onNewValues(updatedValues);
        }}
        onRemoveAll={() => onNewValues([])}
        selected={filters}
      ></DropdownCheckbox>
    </>
  );
};
